import { Add, Delete, InfoOutlined, Luggage} from "@mui/icons-material";
import { Card, IconButton, Stack } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { BusinesstripsContext } from "../contexts";
import { useDictionary, useUser } from "../hooks";
import { renderHeader } from "../utilities";
import HeaderCollapse from "./HeaderCollapse";
import RequestsGeneralPanel from "./RequestsGeneralPanel";


const BusinesstripsPanel = () => {
  const {
    state: { businessTrips },
    setBusinesstrips,
    addBusinesstrip,
    deleteBusinesstrip,
  } = useContext(BusinesstripsContext);
  
  const {user} = useUser();
  const dictionary = useDictionary();

  useEffect(() => {
    setBusinesstrips(user.id);
  }, []);

  return (
    <Card>
      <HeaderCollapse
        color={"businesstrips"}
        title={dictionary["dashboard"]["businessTripRequests"]}
        notificationCount={businessTrips?.length}
        Icon={Luggage}
        actions={
          <Stack direction="row" justifyContent="center" alignItems="center">
            <IconButton
              onClick={() => addBusinesstrip(user.id, dictionary)}
              sx={{ color: (theme) => theme.palette.common.white }}
              size="small"
            >
              <Add fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ color: (theme) => theme.palette.common.white }}
              size="small"
              component={Link}
              to="/approvers"
            >
              <InfoOutlined fontSize="small" />
            </IconButton>
          </Stack>
        }
      />
      <RequestsGeneralPanel
        requests={businessTrips}
        columns={[
          {
            headerName: dictionary["from"],
            renderHeader: renderHeader(dictionary["from"]),
            field: "datefrom",
            flex: 2,
            sortable: false,
            renderCell: ({ value }) =>
              moment(new Date(value)).format("DD/MM/YYYY"),
          },
          {
            headerName: dictionary["to"],
            renderHeader: renderHeader(dictionary["to"]),
            field: "dateto",
            sortable: false,
            flex: 2,
            renderCell: ({ value }) =>
              moment(new Date(value)).format("DD/MM/YYYY"),
          },
          {
            headerName: dictionary["holidays"]["days"],
            renderHeader: renderHeader(dictionary["holidays"]["days"]),
            flex: 1,
            sortable: false,
            field: "days",
          },
          {
            headerName: dictionary["actions"],
            renderHeader: renderHeader(dictionary["actions"]),
            flex: 1,
            sortable: false,
            field: "",
            renderCell: ({ row }) => {
              if (row.status !== "DELETED" && row.status !== "CANCELLED") {
                return (
                  <Stack direction="row">
                    <IconButton
                      onClick={() => {
                        deleteBusinesstrip(row, dictionary, setBusinesstrips, user.id);
                      }}
                      aria-label="delete-request"
                      color="error"
                      size="small"
                    >
                      <Delete fontSize="inherit" />
                    </IconButton>
                  </Stack>
                );
              } else {
                return <></>;
              }
            },
          },
        ]}
      />
    </Card>
  );
};

export default BusinesstripsPanel;
